import commonActions from './common';
import { get } from '../utils/communications';
import { apiEndpoint } from '../utils/env';

export const getAndStore = (reducerName, route, schema, withCursor, params) => (dispatch, getState) => {
  const organisationId = getState().currentOrganisation;
  const actions = commonActions(reducerName);
  const { nextPageCursor: cursor } = getState()[reducerName];
  const paramsToSend = { ...params };
  if (cursor) {
    dispatch(actions.loadMoreItems());
    paramsToSend.cursor = cursor;
  }
  return get(`${apiEndpoint}/organisations/${organisationId}/${route}`, schema, withCursor, paramsToSend)
    .then((info) => {
      const { data, nextPageCursor } = info;
      return dispatch(actions.storeItems(reducerName, { ...data, nextPageCursor }));
    });
};

export const getData = (reducerName, route, schema, withCursor, params) => (dispatch, getState) => {
  const data = getState()[reducerName];
  if (data.allIds.length > 0) {
    return data;
  }
  return dispatch(getAndStore(reducerName, route, schema, withCursor, params));
};



// WEBPACK FOOTER //
// ./src/actions/utils.js